// Core shape interface
export interface ISize {
    width: number;
    height: number;
}

export interface IPoint {
    x: number;
    y: number;
}

// Colors interface
export interface ISimpleColor {
  alpha: number;
  blue: number;
  green: number;
  red: number;
};

export interface IGradientColorItem extends ISimpleColor {
  left: number;
};

export enum IGradientType {
  linear = 'linear',
  radial = 'radial'
}

export interface ICustomGradient {
  type: IGradientType;
  points: IGradientColorItem[];
  degree: number;
};

export type Color = ISimpleColor | ICustomGradient;


export type Track = {
  SoundPaletteKey: string;
  soundPosition: IPoint[];
}

export enum ShapeSchemeType {
  ellipse,
  rectangle,
  polygon,
  blob,
}

export type SimpleShapeSchemeType = ShapeSchemeType.ellipse | ShapeSchemeType.rectangle;
export type ComplexShapeSchemeType = ShapeSchemeType.polygon | ShapeSchemeType.blob;

export interface SimpleShapeScheme {
  point: IPoint;
  size: ISize;
}

export interface ComplexShapeScheme {
  points: IPoint[];
}

type MusicPaperShapeCreator<Types, Data extends {}> = {
  id: string;
  type: Types;
  shapeScheme: Data
  color: Color;
  track: Track | null;
}

export interface SimpleScheme {
  point: IPoint;
  size: ISize;
}

export interface ComplexScheme {
  points: IPoint[];
}

export type SimpleMusicPaperShape = MusicPaperShapeCreator<SimpleShapeSchemeType, SimpleScheme>;
export type ComplexMusicPaperShape = MusicPaperShapeCreator<ComplexShapeSchemeType, ComplexScheme>

export type MusicPaperShape = SimpleMusicPaperShape | ComplexMusicPaperShape;


export interface MusicPaper {
  id: string;
  title: string;
  version: `${number}.${number}.${number}`
  backgroundColor: Color;
  shapeList: MusicPaperShape[]
}